import React from "react";
import HideBookSvg from '@/assets/icons/hide.svg?react';

interface HideBookIconProps {
  size?: "xs" | "sm" | "md" | "lg";
  color?: string;
  className?: string;
}

const HideBookIcon: React.FC<HideBookIconProps> = ({
  size = "md",
  color = "currentColor",
  className = "",
}) => {
  const sizeClasses = {
    xs: "w-4 h-4",
    sm: "w-5 h-5",
    md: "w-6 h-6",
    lg: "w-7 h-7",
  };

  return (
    <HideBookSvg
      fill={color}
      className={`${sizeClasses[size]} ${className}`}
    />
  );
};

export default HideBookIcon;
